import React, { memo, useMemo } from 'react'
import { withStyles } from '@material-ui/core/styles'

import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import PeriodsFilter from './PeriodsFilter'
import DateSessionFilter from './DateSessionFilter'

import UserIcon from 'Assets/Images/icons/user'
import ShareIcon from 'Assets/Images/icons/share'

import style from './style'

function ColumnHeader({
  count,
  classes,
  exportColumn,
  setFiltered,
  name,
  progressOfGetBlockedAmbassadors = {},
  items,
}) {
  const periodsFilterTitle = useMemo(() => {
    if (name === 'interested') {
      return 'Signup date'
    }
    if (name === 'refused') {
      return 'Date since signup'
    }
    if (name === 'preAccess') {
      return 'Date since onboarding'
    }
    if (name === 'finalReview') {
      return 'Date since onboarding'
    }
    if (name === 'approved') {
      return 'Date since the approval'
    }
  }, [name])

  const titleMap = useMemo(
    () => ({
      interested: 'INTERESTED',
      booked: 'BOOKED',
      refused: 'BLOCKED',
      preAccess: 'PRE ACCESS',
      finalReview: 'WAITING FOR REVIEW',
      approved: 'APPROVED',
    }),
    [],
  )

  return (
    <div className={classes.header}>
      <div className={classes.top}>
        <span onClick={exportColumn} className={classes.share}>
          <ShareIcon height="14px" />
        </span>
        <span className={classes.title}>{titleMap[name]}</span>
        <span className={classes.count}>
          <UserIcon height="14px" />
          {progressOfGetBlockedAmbassadors.isLoading && name === 'refused' ? (
            <span className={classes.countIndicatorWrapper}>
              <LoadingIndicator
                label=""
                size="10px"
                style={{ padding: '0px', height: 'auto' }}
              />
            </span>
          ) : (
            count
          )}
        </span>
      </div>
      <div className={classes.content}>
        {name !== 'booked' && (
          <PeriodsFilter
            title={periodsFilterTitle}
            onChange={setFiltered}
            items={items}
            columnName={name}
          />
        )}
        {name === 'booked' && (
          <DateSessionFilter onChange={setFiltered} items={items} />
        )}
      </div>
    </div>
  )
}

export default memo(withStyles(style)(ColumnHeader))



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/ColumnHeader/index.js